<template>
    <div>
    </div>
</template>

<script>
    export default {
        name:'DefaultQueryConditionPane',
        props:['context'],
        data () {
            return {
                name:'DefaultQueryConditionPane',
                bill:null,
                signals:null,
                menuId:null,
            }
        },
        methods:{
            initComponent(){},
            initSignals(){},
        },
        computed:{
            
        },
        created(){
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
        mounted(){
        }
    }
</script>

</<style>
</style>
